import { render, staticRenderFns } from "./AllergyForm.vue?vue&type=template&id=5be3d566"
import script from "./AllergyForm.vue?vue&type=script&lang=js"
export * from "./AllergyForm.vue?vue&type=script&lang=js"
import style0 from "./AllergyForm.vue?vue&type=style&index=0&id=5be3d566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports